var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgVideo = function SvgVideo(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 30.9238L27.5 24.9238V36.9238L36.5 30.9238Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30.9238C11 36.5029 11.5764 39.7764 12.0146 41.4588C12.1317 41.9183 12.3566 42.3432 12.6707 42.6984C12.9848 43.0537 13.379 43.329 13.8207 43.5015C20.0977 45.9136 30.5 45.8474 30.5 45.8474C30.5 45.8474 40.9022 45.9136 47.1792 43.5015C47.6209 43.329 48.0151 43.0537 48.3292 42.6985C48.6433 42.3432 48.8682 41.9183 48.9854 41.4588C49.4236 39.7764 50 36.5029 50 30.9238C50 25.3446 49.4236 22.0712 48.9854 20.3888C48.8683 19.9293 48.6434 19.5043 48.3293 19.1491C48.0152 18.7939 47.621 18.5186 47.1793 18.3461C40.9023 15.9339 30.5 16.0002 30.5 16.0002C30.5 16.0002 20.0978 15.9339 13.8208 18.3461C13.3791 18.5186 12.9849 18.7938 12.6708 19.1491C12.3567 19.5043 12.1318 19.9293 12.0146 20.3887C11.5764 22.0711 11 25.3446 11 30.9238Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgVideo;